//加入统计事件
import { af_logEvent, af_setCustomerUserId } from '@/utils/plugin/sx_appsflyer'
import { firebase_logEvent, firebase_setUserId } from '@/utils/plugin/sx_firebase'

export const logEvent = (eventName: string, eventValues?: any) => {
    console.log('logEvent', eventName, eventValues)
    af_logEvent(eventName, eventValues)
    firebase_logEvent(eventName, eventValues)
}

export const setCustomerUserId = (userId: string) => {
    af_setCustomerUserId(userId)
    firebase_setUserId(userId)
}
